"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(editorState, regex, trigger) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var block = contentState.getBlockForKey(selection.getStartKey());
  var blockText = block && block.getText();
  var offset = selection.getStartOffset();

  if (!selection.isCollapsed() || blockText === undefined) {
    return null;
  }

  var matchArray = blockText.slice(0, offset).match(regex);

  if (matchArray === null) {
    return null;
  }

  var beforeCursorText = matchArray[0].slice(trigger.length);
  var pastCursorMatch = blockText.slice(offset).match(/^\w+/);
  var pastCursorText = pastCursorMatch !== null ? pastCursorMatch[0] : '';
  return {
    search: beforeCursorText + pastCursorText,
    offset: offset - beforeCursorText.length - trigger.length,
    length: trigger.length + beforeCursorText.length + pastCursorText.length
  };
};

exports.default = _default;
module.exports = exports.default;